import { Component, OnInit, AfterViewInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { NEWSLOGOS_CONFIG_DATA } from '../../../configs/newslogos.config';
import AOS from 'aos';
import { RelevantNewsarticleComponent } from '../relevant-newsarticle/relevant-newsarticle.component';

@Component({
  selector: 'app-news-sixth-anniversary',
  imports: [CommonModule, RelevantNewsarticleComponent],
  standalone: true,
  templateUrl: './news-sixth-anniversary.component.html',
  styleUrl: './news-sixth-anniversary.component.scss'
})
export class NewsSixthAnniversaryComponent implements OnInit, AfterViewInit, OnDestroy {
  public newsLogData: any = [];
  public displayedItems: any[] = [];
  private itemsPerPage = 12; // Number of items to load per batch
  private currentPage = 1;   // Track current page
  private jsonLdScript: any;

  constructor(private router: Router,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }
  ngAfterViewInit() {
    AOS.init();
  }
  ngOnInit(): void {
    this.injectSchemaMarkup();
    this._newsLogTemplateData();
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }
  nav(url: any) {
    this.router.navigateByUrl(url);
  }
injectSchemaMarkup(): void {
    const anniversarySchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/kalpita-press-release/kalpita-sixth-anniversary",
          "url": "https://www.kalpitatechnologies.com/kalpita-press-release/kalpita-sixth-anniversary",
          "name": "Kalpita Celebrates 6 Years of Innovation — Kalpita Technologies",
          "description": "Kalpita Technologies celebrates its 6th anniversary with over 100 industry leaders, highlighting six years of innovation, Bangalore office expansion, and CEO Kube G's vision.",
          "speakable": {
            "@type": "SpeakableSpecification",
            "cssSelector": [
              ".banner-heading-one",
              ".section-title",
              ".section-description"
            ]
          },
          "datePublished": "2024-11-01",
          "dateModified": "2024-11-01",
          "isPartOf": { "@type": "WebSite", "@id": "https://www.kalpitatechnologies.com/#website" }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/kalpita-press-release/kalpita-sixth-anniversary#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.kalpitatechnologies.com/" },
            { "@type": "ListItem", "position": 2, "name": "News", "item": "https://www.kalpitatechnologies.com/kalpita-press-release/inthenews" },
            { "@type": "ListItem", "position": 3, "name": "6th Anniversary Celebration", "item": "https://www.kalpitatechnologies.com/kalpita-press-release/kalpita-sixth-anniversary" }
          ]
        },
        {
          "@type": "TechArticle",
          "headline": "Kalpita Technologies Celebrates 6 Years of Innovation",
          "alternativeHeadline": "Six Years of Transforming Software Delivery with Office Expansion and Future-Ready Growth",
          "articleBody": "Kalpita Technologies commemorated six years of innovation and growth with an engaging anniversary event featuring team members and business leaders. A major highlight was the expansion of the Bangalore office including privacy pods and rejuvenation stations...",
          "author": { "@type": "Organization", "name": "Kalpita Technologies" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2024-11-01"
        },
        {
          "@type": "HowTo",
          "name": "How to Celebrate a Company Milestone Like Kalpita Technologies",
          "description": "Step-by-step guide to organizing a meaningful corporate anniversary event.",
          "step": [
            { "@type": "HowToStep", "name": "Organize Event", "text": "Plan an engaging celebration with team members and industry leaders." },
            { "@type": "HowToStep", "name": "Leadership Keynote", "text": "Deliver a vision speech reflecting on the journey and future growth." },
            { "@type": "HowToStep", "name": "Workplace Upgrades", "text": "Announce office expansion and investments in employee experience." },
            { "@type": "HowToStep", "name": "Foster Culture", "text": "Commit to training and a learning-driven development culture." },
            { "@type": "HowToStep", "name": "Amplify Success", "text": "Share achievements across major technology and news platforms." }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What was celebrated at Kalpita Technologies' 6th anniversary?",
              "acceptedAnswer": { "@type": "Answer", "text": "Six years of innovation, growth, and the announcement of office expansion with upgraded amenities." }
            },
            {
              "@type": "Question",
              "name": "How did the office expand?",
              "acceptedAnswer": { "@type": "Answer", "text": "By adding additional floor space and introducing privacy pods and rejuvenation stations for employee wellness." }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.kalpitatechnologies.com/#localbusiness",
          "name": "Kalpita Technologies — Austin Office",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Suite #300, 3rd Floor, Building 2, 1250 South Capital of Texas Highway",
            "addressLocality": "Austin",
            "addressRegion": "TX",
            "postalCode": "78746",
            "addressCountry": "US"
          },
          "telephone": "+1-512-240-2484",
          "url": "https://www.kalpitatechnologies.com/"
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(anniversarySchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }
  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  // Load news data and initialize the displayed items
  private _newsLogTemplateData() {
    this.newsLogData = NEWSLOGOS_CONFIG_DATA;
    this.displayedItems = this.newsLogData.slice(0, this.itemsPerPage);
  }

  // Load more items when 'Expand More' button is clicked
  loadMore() {
    this.currentPage++;
    const nextItems = this.newsLogData.slice(0, this.itemsPerPage * this.currentPage);
    this.displayedItems = nextItems;
  }

  // To check if 'Expand More' button should be shown
  showExpandMore(): boolean {
    return this.displayedItems.length < this.newsLogData.length;
  }
}
